module.exports = __webpack_public_path__ + "img/visa.f956dfc6.png";